import type { ThemeConfig } from 'antd/es/config-provider/context'

export const colors = {
  navy: '#14213D',
  navyDeep: '#071F3B',
  blue: '#2563EB',
  orange: '#F59E0B',
  green: '#059669',
  red: '#DC2626',
  gray50: '#F7F8FA',
  gray100: '#F1F5F9',
  border: '#E5E7EB',
  text: '#14213D',
  muted: '#64748B',
  white: '#FFFFFF',
} as const

export const yihangTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.blue,
    colorSuccess: colors.green,
    colorWarning: colors.orange,
    colorError: colors.red,
    colorInfo: colors.blue,
    colorText: colors.text,
    colorTextSecondary: colors.muted,
    colorBorder: colors.border,
    colorBgBase: colors.white,
    colorBgLayout: colors.gray50,
    borderRadius: 8,
    borderRadiusLG: 8,
    fontFamily: 'Inter, "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif',
    fontSize: 14,
    controlHeight: 40,
    controlHeightSM: 32,
    boxShadow: '0 4px 16px rgba(20, 33, 61, 0.06)',
    boxShadowSecondary: '0 8px 24px rgba(20, 33, 61, 0.08)',
  },
  components: {
    Button: {
      borderRadius: 6,
      fontWeight: 600,
      primaryShadow: 'none',
    },
    Card: {
      borderRadiusLG: 8,
      headerBg: colors.white,
    },
    Drawer: {
      borderRadiusLG: 0,
    },
    Input: {
      activeShadow: '0 0 0 2px rgba(37, 99, 235, 0.12)',
    },
    Menu: {
      darkItemBg: colors.navyDeep,
      darkItemSelectedBg: colors.blue,
      darkItemHoverBg: '#12375E',
      itemBorderRadius: 6,
    },
    Modal: {
      borderRadiusLG: 8,
    },
    Table: {
      headerBg: '#F8FAFC',
      headerColor: colors.text,
      borderColor: colors.border,
      rowHoverBg: '#F8FBFF',
      cellPaddingBlock: 12,
      cellPaddingInline: 12,
    },
    Tabs: {
      itemSelectedColor: colors.blue,
      inkBarColor: colors.blue,
      horizontalItemPadding: '12px 4px',
    },
    Tag: {
      borderRadiusSM: 5,
    },
  },
}
